import { api } from '../http'
import {
  AdminOperationsResponseSchema,
  OperationsAlertSummarySchema,
  PromotionRequestSchema,
} from '../adminOperationsSchemas'

export const getAdminOperations = () =>
  api.get('/admin/operations', AdminOperationsResponseSchema)

export const getAdminOperationsAlert = () =>
  api.get('/admin/operations/alert', OperationsAlertSummarySchema)

export const createGitlabPromotion = (input: {
  confirmation: string
  acknowledge_primary_fenced: boolean
}) => api.post('/admin/operations/promotions', input, PromotionRequestSchema)
